import { Injectable, inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ChangePasswordFormGroup } from './auth-user-form-group.interface';
import {
  hasDigit,
  hasLowerCase,
  hasNonAlphaNumeric,
  hasUpperCase,
} from '../../validators/password-validators';

@Injectable()
export class ChangePasswordFormModel {
  public readonly fieldNames = {
    currentPassword: 'currentPassword',
    newPassword: 'newPassword',
    confirmPassword: 'confirmPassword',
  };

  public form: FormGroup<ChangePasswordFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<ChangePasswordFormGroup>({
      currentPassword: new FormControl('', {
        nonNullable: true,
      }),
      newPassword: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(6),
          hasDigit,
          hasLowerCase,
          hasUpperCase,
          hasNonAlphaNumeric,
        ],
      }),
      confirmPassword: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(6),
          hasDigit,
          hasLowerCase,
          hasUpperCase,
          hasNonAlphaNumeric,
          this.isEqualPasswords,
        ],
      }),
    });
  }

  private isEqualPasswords = (control: AbstractControl) => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return this.form.get('newPassword')?.value === value
      ? null
      : { passwordsNotEqual: true };
  };
}
